import { useRouteError, isRouteErrorResponse, useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { HomeIcon, RefreshCw } from 'lucide-react'

export function ErrorBoundary() {
  const error = useRouteError()
  const navigate = useNavigate()

  let errorMessage = 'An unexpected error occurred.'
  let errorTitle = 'Oops!'
  
  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      errorTitle = '404 - Page Not Found'
      errorMessage = "Sorry, we couldn't find the page you're looking for."
    } else if (error.status === 401) {
      errorTitle = 'Unauthorized'
      errorMessage = 'Please log in to access this page.'
    } else if (error.status === 503) {
      errorTitle = "Service Unavailable"
      errorMessage = "Sorry, we're experiencing technical difficulties."
    } else {
      errorTitle = `${error.status} - ${error.statusText}`
      errorMessage = error.data?.message || 'An error occurred while processing your request.'
    }
  } else if (error instanceof Error) {
    errorMessage = error.message
  }

  return (
    <div className="min-h-screen bg-[#F3F4F6] dark:bg-[#101624] flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white/80 dark:bg-[#182438]/80 backdrop-blur-xl backdrop-saturate-150 p-8 rounded-xl border border-[#2F2F2F]/10 dark:border-[#333840] text-center">
        <h1 className="text-3xl font-bold mb-4 bg-gradient-to-r from-[#1C1C1C] to-[#383838] dark:from-[#E8E8E8] dark:to-[#CCCCCC] bg-clip-text text-transparent">
          {errorTitle}
        </h1>
        <p className="text-[#2F2F2F] dark:text-[#A3A3A3] mb-8">
          {errorMessage}
        </p>
        <div className="flex gap-4 justify-center">
          <Button
            variant="outline"
            onClick={() => window.location.reload()}
            className="flex items-center gap-2"
          >
            <RefreshCw className="h-4 w-4" />
            Try Again
          </Button>
          <Button
            className="bg-[#439476] text-white hover:bg-[#387565] flex items-center gap-2"
            onClick={() => navigate('/')}
          >
            <HomeIcon className="h-4 w-4" />
            Go Home
          </Button>
        </div>
      </div>
    </div>
  )
}
